import { useEffect, useRef, useState } from 'react';
import { copyText } from '../lib/clipboard';

interface CopyableVersionTagProps {
  version: string;
}

export const CopyableVersionTag = ({ version }: CopyableVersionTagProps) => {
  const [toastVisible, setToastVisible] = useState(false);
  const timeoutRef = useRef<number>();

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        window.clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const handleCopy = async () => {
    try {
      await copyText(version);
      setToastVisible(true);
    } catch (error) {
      console.error('Failed to copy version:', error);
      return;
    }

    if (timeoutRef.current) {
      window.clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = window.setTimeout(() => {
      setToastVisible(false);
    }, 1800);
  };

  return (
    <span className='relative inline-flex'>
      <button
        type='button'
        onClick={handleCopy}
        className='px-2 py-0.5 bg-gray-100 text-gray-600 rounded text-xs font-mono hover:bg-gray-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring cursor-pointer transition-colors'
        aria-label={`Copy version ${version}`}
        title='Copy version'
      >
        {version}
      </button>
      {toastVisible && (
        <div
          role='status'
          className='absolute bottom-full left-1/2 z-50 mb-1.5 -translate-x-1/2 whitespace-nowrap rounded bg-gray-900 px-2 py-1 text-xs text-white shadow-md'
        >
          Copied
        </div>
      )}
    </span>
  );
};
